module.exports = __webpack_public_path__ + "img/list_w.dbefc63f.svg";